/**
 * Unified Device ID — one persistent, recognizable identity per browser/device.
 *
 * Generates fun, memorable names like "happy_octopus" or "brave_panda".
 * If a PIN-based participantId exists, uses that instead.
 * Persists in localStorage across sessions.
 */

const KEY = 'kuutio-device-id';

const ADJECTIVES = [
  'happy', 'brave', 'clever', 'funny', 'kind',
  'swift', 'bold', 'calm', 'eager', 'gentle',
  'jolly', 'lively', 'merry', 'noble', 'proud',
  'quick', 'sharp', 'warm', 'wise', 'bright',
];

const ANIMALS = [
  'octopus', 'panda', 'falcon', 'dolphin', 'fox',
  'owl', 'bear', 'wolf', 'eagle', 'otter',
  'lynx', 'raven', 'elk', 'seal', 'swan',
  'hawk', 'hare', 'deer', 'crane', 'tiger',
];

function generateFunId() {
  const adj = ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)];
  const animal = ANIMALS[Math.floor(Math.random() * ANIMALS.length)];
  const num = Math.floor(Math.random() * 100);
  return `${adj}_${animal}_${num}`;
}

export function getDeviceId() {
  let id = localStorage.getItem(KEY);
  if (!id) {
    // Reuse PIN-based participantId if already set
    const participantId = localStorage.getItem('participantId');
    id = participantId || generateFunId();
    localStorage.setItem(KEY, id);
  }
  return id;
}

export function withDeviceIdHeaders(init = {}) {
  const headers = new Headers(init.headers || {});
  if (!headers.has('X-Device-Id')) {
    headers.set('X-Device-Id', getDeviceId());
  }
  return { ...init, headers };
}
